export function initAccordions() {
  const buttons = document.querySelectorAll(".js-accordian-btn");
  if (!buttons.length) return;

  buttons.forEach(function (button) {
    button.addEventListener("click", function () {
      button.classList.toggle("is-active");

      const panel = button.nextElementSibling;
      if (!panel) return;

      panel.classList.toggle("is-open");

      if (panel.classList.contains("is-open")) {
        panel.style.display = "block";
        panel.style.height = panel.scrollHeight + "px";
      } else {
        panel.style.height = "0";
        setTimeout(function () {
          panel.style.display = "none";
        }, 300);
      }
    });
  });
}

initAccordions();
